<script setup>
import {Link} from '@inertiajs/inertia-vue3';
import {computed, defineAsyncComponent, ref} from "vue";

const props = defineProps({
  icon: String | null,
  svg: String | null,
  label: String,
  href: String,
  exact: Boolean,
});
let defaultSvgColor = '#9CA3AF';
const linkColor = ['text-gray-400'];
const linkActive = ['text-cyan-500'];
const linkClasses = ['flex', 'items-center', 'p-2', 'rounded-lg', 'group', 'hover:bg-gray-100', 'hover:text-cyan-500']
const textColor = ['text-gray-400'];
const textActive = ['text-cyan-500'];
let textClasses = ['fa', 'w-6', 'h-6', 'text-center', 'text-xl', 'transition', 'duration-75', 'group-hover:text-cyan-500'];
let aClasses = [];
let spanClasses = [];

if (props.icon) {
  textClasses = [...textClasses, `fa-${props.icon}`];
}

const currentPath = window.location.pathname;
let targetPath = props.href;

try {
  targetPath = new URL(props.href, window.location.origin).pathname;
} catch (e) {}

const isActive = props.exact
  ? currentPath === targetPath
  : currentPath === targetPath || currentPath.startsWith(`${targetPath}/`);

if (isActive) {
  aClasses = [...linkActive, ...linkClasses];
  spanClasses = [...textActive, ...textClasses];
  defaultSvgColor = '#06B6D4';
} else {
  aClasses = [...linkColor, ...linkClasses];
  spanClasses = [...textColor, ...textClasses];
}

const isDefaultTag = () => {
  return props.href.startsWith('/content') || !props.href.includes('uniformsourcing');
}
let component = null;

if (props.svg) {
  component = computed(
    () => defineAsyncComponent(() => import(`@/Components/Common/Svg/${props.svg}.vue`))
  );
}

const svgColor = ref(defaultSvgColor);
const mouseEnter = () => {
  svgColor.value = '#06B6D4';
}

const mouseLeave = () => {
  svgColor.value = defaultSvgColor;
}

</script>

<template>
  <a :href="href" v-if="isDefaultTag()" :class="aClasses" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <span :class="spanClasses"><component :is="component" class="w-6 h-6" :color="svgColor"></component></span>
    <span v-text="label" class="flex-1 whitespace-nowrap ml-3"></span>
  </a>
  <Link :href="href" v-else :class="aClasses" @mouseenter="mouseEnter" @mouseleave="mouseLeave">
    <span :class="spanClasses"><component :is="component" class="w-6 h-6" :color="svgColor"></component></span>
    <span v-text="label" class="flex-1 whitespace-nowrap ml-3"></span>
  </Link>
</template>
